import React from "react";
// import styles from "./Dashboard.module.css";
// import Moment from "moment";

const TradeData = ({ tradeData }) => {
  const style = {
    hideScrollbar: "overflow-x-auto scrollbar-hide"
  };

  // Add this CSS to your global stylesheet or in a CSS-in-JS solution
  const globalStyles = `
    .scrollbar-hide::-webkit-scrollbar {
      display: none;
    }
    .scrollbar-hide {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
  `;

  // Inject the styles into the document head
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = globalStyles;
  document.head.appendChild(styleSheet);

  return (
    <div>
      {!tradeData && !tradeData ? (
        <div className=" mt-10 w-full h-[calc(100vh-240px)]  md:h-[calc(100vh-400px)] custom-scroll overflow-x-auto  ">
          <table className="  text-sm w-full relative z-0">
            <thead className=" text-sm text-left  border-b-[1px] border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
              <tr className="text-white ">
                <th className="py-6 text-left pl-4 text-[14px] font-medium rounded-tl-lg ">
                  DATE
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  SYMBOL
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  POSITION
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  ENTRY POINT
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  QUANTITY
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  EXIT POINT
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  QUANTITY
                </th>
                <th className="py-6 text-right px-2 text-[14px] font-medium">
                  PNL VALUE
                </th>
                <th className="py-6 text-right pr-4 text-[14px] font-medium rounded-tr-lg ">
                  PNL(in%)
                </th>
              </tr>
            </thead>
          </table>
          <span className="w-full text-white text-2xl md:text-4xl flex flex-row justify-center py-16">
            No Data Available
          </span>
        </div>
      ) : tradeData && tradeData.length === 0 ? (
        <div className=" mt-10 w-full h-[calc(100vh-240px)]  md:h-[calc(100vh-400px)] custom-scroll overflow-x-auto   ">
          <table className="  text-sm w-full relative z-0">
            <thead className=" text-sm text-left  border-b-[1px]   border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
              <tr className="text-white ">
                <th className="py-6 text-left pl-4 text-[14px] font-medium rounded-tl-lg ">
                  DATE
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  SYMBOL
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  POSITION
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  ENTRY POINT
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  QUANTITY
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  EXIT POINT
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  QUANTITY
                </th>
                <th className="py-6 text-right px-2 text-[14px] font-medium">
                  PNL VALUE
                </th>
                <th className="py-6 text-right pr-4 text-[14px] font-medium rounded-tr-lg ">
                  PNL(in%)
                </th>
              </tr>
            </thead>
          </table>
          <span className="w-full text-white text-2xl md:text-4xl flex flex-row justify-center py-16">
            No Data Available
          </span>
        </div>
      ) : (
        <div className={`mt-10 w-full h-[calc(100vh-240px)] md:h-[calc(100vh-400px)] custom-scroll ${style.hideScrollbar}`}>
          <table className="  text-sm w-full relative  z-0">
            <thead className=" text-sm text-left  border-b-[1px]   border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
              <tr className="text-[#ffffff]/60 ">
                <th className="py-6 text-left pl-4 text-[14px] font-medium rounded-tl-lg ">
                  DATE
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  SYMBOL
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  POSITION
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  ENTRY POINT
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  QUANTITY
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  EXIT POINT
                </th>
                <th className="py-6 text-left px-2 text-[14px] font-medium">
                  QUANTITY
                </th>
                <th className="py-6 text-right px-2 text-[14px] font-medium">
                  PNL VALUE
                </th>
                <th className="py-6 text-right pr-4 text-[14px] font-medium rounded-tr-lg ">
                  PNL(in%)
                </th>
              </tr>
            </thead>
            <tbody className=" shadow-custom-inner backdrop-blur-custom bg-black ">
              {tradeData &&
                tradeData.map((dataItem, i) => {
                  const pnlPercent = dataItem[8] && dataItem[8];
                  return (
                    <tr key={i} className=" z-0 border-b border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-left py-3  px-3 pl-4">
                        {/* {Moment(dataItem[0], "DD/MM/YYYY").format("DD-MM-YYYY")} */}
                        {dataItem[0]}
                      </td>
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 ">
                        {dataItem[1]}
                      </td>
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 ">
                        {dataItem[2]}
                      </td>
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 ">
                        {dataItem[3]}
                      </td>
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 ">
                        {dataItem[4]}
                      </td>
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 ">
                        {dataItem[5]}
                      </td>
                      <td className="text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 ">
                        {dataItem[6]}
                      </td>
                      <td
                        className={`text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 
                      ${
                        parseFloat(dataItem[7]) > 0
                          ? `text-[#18b13f]`
                          : parseFloat(dataItem[7]) < 0
                          ? ` text-[#eb323f]`
                          : `text-[#f2f2f2]`
                      }
                      `}
                      >
                        {dataItem[7]}
                      </td>
                      <td
                        className={`text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 
                      ${
                        parseFloat(dataItem[8]) > 0
                          ? `text-[#18b13f]`
                          : parseFloat(dataItem[8]) < 0
                          ? `text-[#eb323f]`
                          : `text-[#f2f2f2]`
                      }
                      `}
                      >
                        {parseFloat(pnlPercent).toFixed(2)} %
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TradeData;
